import { createApiCallActions } from '../../../common/store/generic.actions';
import {
  ContactChildrenLightModel,
  ContactDetailModel,
  ContactFormModel,
  ContactModel,
  ContactNameModel,
} from './types';

export const contactActions = {
  getById: createApiCallActions<ContactDetailModel>('contact', 'getById'),
  getFormById: createApiCallActions<ContactFormModel>(
    'contact',
    'contactFormModel',
  ),
  postContact: createApiCallActions<ContactModel>('contact', 'postContact'),
  updateContact: createApiCallActions<ContactModel>('contact', 'updateContact'),
  createInstance: createApiCallActions<ContactModel>(
    'contact',
    'createInstance',
  ),
  getChildren: createApiCallActions<ContactChildrenLightModel[]>(
    'contact',
    'getChildren',
  ),
  getNewestContactNameByEmail: createApiCallActions<ContactNameModel>(
    'contact',
    'getNewestContactNameByEmail',
  ),
};

export type ContactAction = typeof contactActions;
